<template>
  <div>
    <div class="page-title">New Custom Component</div>
    <Form v-model="form" :submit="create" btnText="Add Custom Component" />
  </div>
</template>

<script>
import Form from "./_form.custom-components.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.CustomComponent.new();
      this.form = data;
    },
    async create() {
      await this.$api.CustomComponent.create(this.form);
      this.$router.push("/dev-tools/custom-components");
    },
  },
};
</script>

<style></style>
